module.exports = __webpack_public_path__ + "img/photo-of-dining-table-with-chairs-3258303.646feeb9.jpg";